module.exports = __webpack_public_path__ + "fonts/geist-mono.var.69a38b6.woff";